import Splide from '@splidejs/splide';
import '@splidejs/splide/css';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.client-testimonials-section').forEach((section) => {
        const ctsSlider = section.querySelector('.cts-content-slider');

        new Splide(ctsSlider, {
            type: 'loop',
            drag: false,
            gap: '24px',
            arrows: false,
            direction: 'ttb',
            pagination: false,
            autoWidth: true,
            height: '80dvh',
            autoScroll: {
                speed: 0.3,
                pauseOnHover: false,
            },
            clones: 12,
            extensions: { AutoScroll }, // register the extension
        }).mount({ AutoScroll }); // mount the extension
    });
});
